import { useAuth } from '@/hooks/useAuth';
import { useGetCurrentTenantQuery } from '@/store/api/apiSlice';
import { useTranslation } from 'react-i18next';
import { UserRole } from '@/types';
import RouteAccessDenied from './RouteAccessDenied';

/** Blocks /economics when tenant has not enabled project economics. */
export default function EconomicsGuard({ children }: { children: JSX.Element }) {
  const { user } = useAuth();
  const { t } = useTranslation();
  const { data: tenant, isLoading } = useGetCurrentTenantQuery(undefined);

  if (isLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center bg-gray-50" />
    );
  }

  const enabled = Boolean((tenant?.settings as { economics?: { enabled?: boolean } } | undefined)?.economics?.enabled);

  if (!enabled && user?.role !== UserRole.SUPER_ADMIN) {
    return (
      <RouteAccessDenied
        title={t('economicsGuard.disabledTitle')}
        message={t('economicsGuard.disabledMsg')}
        actionLabel={t('economicsGuard.openOrgSettings')}
        actionTo="/admin/org-settings"
      />
    );
  }

  return children;
}
